<template>
  <div class="flex flex-col gap-3">
    <Field :rules="requiredRule" name="emirateId" v-slot="{ field, errors: errs, handleChange }">
      <Dropdown
        :field="field"
        :errors="errs"
        :label="$t('emirate')"
        :options="emirates"
        :fuse-options="{
          threshold: 0.9
        }"
        class="px-0.5 w-full md:w-1/2"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></Dropdown>
    </Field>
    <Field :rules="requiredRule" name="licenseNumber" v-slot="{ field, errors: errs }">
      <TextInput
        :field="field"
        :errors="errs"
        :placeholder="$t('estabLicenseNumber')"
        :max-length="25"
        :label="$t('estabLicenseNumber')"
        mask="#########################"
        class="px-0.5 w-full md:w-1/2"
        label-class="w-full"
        direction="flex-col"
      >
      </TextInput>
    </Field>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import Dropdown from '@/components/SimpleForm/Dropdown.vue'
import RadioGroup from '@/components/SimpleForm/RadioGroup.vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const props = defineProps({
  departments: Array
})

const i18n = useI18n()

const emirates = computed(() => {
  return props.departments.map((d) => {
    const { admninstrativeRegion } = d
    return {
      ...admninstrativeRegion,
      label: admninstrativeRegion.text,
      value: admninstrativeRegion.id
    }
  })
})

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}
</script>

<style lang="scss" scoped></style>
